/**
 * tool-handoff.js — «Что дальше»: результат одного инструмента уезжает в соседний
 * БЕЗ повторного скачивания и загрузки.
 *
 * Зачем: комментарий #1227 (Иван/Mr.Sanktum) — «можно все ваши эти инструменты
 * собрать в один видео редактор». Монолит-редактор мы не строим (сила узких тулов
 * в том, что они открываются мгновенно), но настоящая боль за просьбой — беготня
 * «скачай из одного, загрузи в другой». Это ровно то, что у iLovePDF решают
 * Workflows: одна загрузка на всю цепочку. Здесь — лёгкая версия: панель результата
 * предлагает соседние инструменты, файл переносится внутри браузера.
 *
 * МОДУЛЬ, а не правка тула:
 *   • продюсер (тул с результатом) — одна строка: __toolHandoff.mount(railEl, getResult)
 *   • приёмник — НИЧЕГО не пишет: файл сам приезжает в общий <x-tool-uploader>
 *     через ToolUploader.inject(..., 'inter_tool_route') — этот вход в аплоадере
 *     был предусмотрен изначально (см. комментарий над inject).
 *   • какие инструменты предлагать — config/tool-handoff.php, а не код.
 *
 * ТРАНСПОРТ — Cache API. Замер на 200 МБ (реальный прод-origin, 2026-07-30):
 * запись 373 мс, чтение после навигации 3 мс, байты целы; OPFS на той же задаче —
 * 948 мс на запись и требует отдельно хранить имя файла. Cache API к тому же уже
 * применяется здесь для share-target. Квота origin была 4105 МБ.
 *
 * ГЕЙТЫ (Фарид, 2026-07-30): предложение показываем НЕ ВСЕМ, а только когда переход
 * реально сработает. Каждый чип проверяется отдельно и просто НЕ показывается, если:
 *   1. нет транспорта или мало свободного места в квоте;
 *   2. целевой тул НЕ ПРИНИМАЕТ этот формат — проверка идёт той же функцией
 *      matchesAccept, которой аплоадер цели и будет проверять файл (мы возим наш
 *      же .webm-фолбэк, для части тулов он неприемлем);
 *   3. файл больше адаптивного капа цели на ЭТОМ устройстве
 *      (__effectiveFileLimit — тот же источник, что показывает подсказку размера);
 *   4. на устройстве мало памяти для повторной обработки такого файла;
 *   5. у пользователя не осталось запусков целевого тула (__toolLimit.remaining).
 * Причина отказа уходит в телеметрию — чтобы видеть, что и почему скрывается,
 * а не гадать (до этой волны находимость обрезки не измерялась вовсе).
 *
 * ПОДСКАЗКИ (25.09.2026): результат может нести `hints` — маленький JSON о том, КАК
 * его встретить (мэшап → «Видео для Reels» везёт шаблон 'reel' и название песен).
 * Едут заголовком рядом с файлом; приёмник объявляет их событием
 * `tool-handoff:arrived` {from, hints, file} и в window.__toolHandoffArrival (тул,
 * провязавший слушатель позже приезда, прочтёт оттуда). Тул без слушателя их просто
 * не замечает: файл приезжает как раньше.
 */
(function () {
    'use strict';

    var CACHE_NAME = 'tmb-handoff';
    var KEY = '/tmb-handoff/payload';
    var TTL_MS = 10 * 60 * 1000;
    var PARAM = 'tmb_in';
    var HDR_NAME = 'X-Tmb-Name', HDR_FROM = 'X-Tmb-From', HDR_TS = 'X-Tmb-Ts', HDR_HINTS = 'X-Tmb-Hints', HDR_COUNT = 'X-Tmb-Count';
    var MAX_FILES = 16;   // putMany: столько фото берёт генератор картинок (GPT Image 2.5)

    /* Приём происходит в самом начале жизни страницы, когда telemetry-tier0 может быть
       ещё не поднят. Прежняя версия в этом случае молча выбрасывала событие — и провал
       приёма выглядел в данных как «ничего не было» (ровно эта слепота уже стоила нам
       месяцев на необнаруженной проблеме с обрезкой). Ждём __ae до 20 с и только потом
       сдаёмся. */
    function ae(f, extra) {
        var p = { slug: (window.__TOOL_SLUG || (document.querySelector('meta[name="tool-slug"]') || {}).content || ''), f: f };
        if (extra) for (var k in extra) if (Object.prototype.hasOwnProperty.call(extra, k)) p[k] = extra[k];
        var tries = 0;
        (function send() {
            try {
                if (typeof window.__ae === 'function') { window.__ae('feature_use', p); return; }
            } catch (_) { return; }
            if (++tries < 100) setTimeout(send, 200);
        })();
    }

    function canTransport() {
        return !!(window.caches && window.File && window.Blob && navigator.storage);
    }

    /* Адрес перехода с меткой переноса. Метка — часть запроса и обязана стоять
       ДО якоря: «…/tool#edit?tmb_in=1» браузер читает как якорь «edit?tmb_in=1»,
       приёмник метки не видит, и файл остаётся в кэше, а человек — у пустого
       инструмента. Якорь нужен целям, которые по нему открывают нужный режим
       (правка фото в генераторе картинок, 07.10.2026). */
    function withParam(url) {
        var i = url.indexOf('#');
        var base = i === -1 ? url : url.slice(0, i), hash = i === -1 ? '' : url.slice(i);
        return base + (base.indexOf('?') === -1 ? '?' : '&') + PARAM + '=1' + hash;
    }

    function freeBytes() {
        if (!navigator.storage || !navigator.storage.estimate) return Promise.resolve(Infinity);
        return window.__storageEstimate().then(function (e) {
            return Math.max(0, (e.quota || 0) - (e.usage || 0));
        }).catch(function () { return Infinity; });
    }

    /* Кладём результат под ОДНИМ ключом: одновременно в полёте всегда один переход,
       а перезапись сама убирает предыдущий (никакого мусора в квоте). */
    function put(blob, filename, fromSlug, hints) {
        return caches.open(CACHE_NAME).then(function (c) {
            return dropExtras(c).then(function () {
                return c.put(KEY, new Response(blob, { headers: headersFor(blob, filename, fromSlug, hints, 1) }));
            });
        });
    }

    function headersFor(blob, filename, fromSlug, hints, count) {
        var h = { 'Content-Type': blob.type || 'application/octet-stream' };
        h[HDR_NAME] = encodeURIComponent(filename || 'file');
        h[HDR_FROM] = fromSlug || '';
        h[HDR_TS] = String(Date.now());
        if (count > 1) h[HDR_COUNT] = String(count);
        if (hints) { try { h[HDR_HINTS] = encodeURIComponent(JSON.stringify(hints)).slice(0, 4000); } catch (_) {} }
        return h;
    }

    /* НЕСКОЛЬКО файлов одним переходом (28.10.2026): «Совместное фото» из
       «Объединить фото» везёт в генератор картинок оба снимка — с одним вторым
       человеком на снимке не было бы. Первый файл лежит под прежним ключом и
       несёт счёт, остальные — под KEY/1…KEY/n−1. Ключ пишется ПОСЛЕДНИМ: он и
       есть отметка «перенос готов», полузаписанная пачка не читается. */
    function putMany(list, fromSlug, hints) {
        var items = (list || []).filter(function (x) { return x && x.blob && x.blob.size; }).slice(0, MAX_FILES);
        if (!items.length) return Promise.reject(new Error('empty-result'));
        if (items.length === 1) return put(items[0].blob, items[0].filename, fromSlug, hints);
        return caches.open(CACHE_NAME).then(function (c) {
            return dropExtras(c).then(function () {
                return Promise.all(items.slice(1).map(function (x, i) {
                    return c.put(KEY + '/' + (i + 1), new Response(x.blob, { headers: headersFor(x.blob, x.filename, fromSlug, null, 1) }));
                }));
            }).then(function () {
                return c.put(KEY, new Response(items[0].blob, { headers: headersFor(items[0].blob, items[0].filename, fromSlug, hints, items.length) }));
            });
        });
    }

    function dropExtras(c) {
        var all = [];
        for (var i = 1; i < MAX_FILES; i++) all.push(c.delete(KEY + '/' + i).catch(function () {}));
        return Promise.all(all);
    }

    function fileOf(res, b) {
        var name = res.headers.get(HDR_NAME) || 'file';
        try { name = decodeURIComponent(name); } catch (_) {}
        return new File([b], name, { type: res.headers.get('Content-Type') || b.type || '' });
    }

    /* Забираем и СРАЗУ удаляем: файл пользователя не должен лежать в браузере
       дольше, чем нужно на один переход (та же дисциплина, что у download-stash). */
    function take() {
        if (!window.caches) return Promise.resolve(null);
        return caches.open(CACHE_NAME).then(function (c) {
            return c.match(KEY).then(function (res) {
                if (!res) return null;
                var ts = parseInt(res.headers.get(HDR_TS) || '0', 10);
                var from = res.headers.get(HDR_FROM) || '';
                var name = res.headers.get(HDR_NAME) || 'file';
                try { name = decodeURIComponent(name); } catch (_) {}
                var hints = null;
                try { var hh = res.headers.get(HDR_HINTS); if (hh) hints = JSON.parse(decodeURIComponent(hh)); } catch (_) { hints = null; }
                var stale = !ts || (Date.now() - ts) > TTL_MS;
                return res.blob().then(function (b) {
                    /* ⚠️ НЕ удаляем здесь. Раньше запись стиралась сразу после чтения —
                       и если отдать файл было НЕКУДА (зоны аплоадера провязываются на
                       DOMContentLoaded, приёмник мог опередить их), файл исчезал
                       БЕЗВОЗВРАТНО: пользователь приезжал на пустой инструмент, а его
                       результат уже удалён. Теперь удаляет только тот, кто реально
                       доставил файл (см. drop() в receive). Просроченное подметает
                       sweep() и повторная запись под тем же ключом. */
                    if (stale || !b || !b.size) { c.delete(KEY).catch(function () {}); dropExtras(c); return null; }
                    var type = res.headers.get('Content-Type') || b.type || '';
                    var first = new File([b], name, { type: type });
                    var count = Math.min(MAX_FILES, parseInt(res.headers.get(HDR_COUNT) || '1', 10) || 1);
                    var rest = [];
                    for (var i = 1; i < count; i++) {
                        rest.push(c.match(KEY + '/' + i).then(function (r) {
                            return r ? r.blob().then(function (bb) { return bb && bb.size ? fileOf(r, bb) : null; }) : null;
                        }).catch(function () { return null; }));
                    }
                    return Promise.all(rest).then(function (more) {
                        var files = [first].concat(more.filter(Boolean));
                        var size = files.reduce(function (s, f) { return s + f.size; }, 0);
                        return { file: first, files: files, from: from, size: size, hints: hints,
                                 drop: function () { return caches.open(CACHE_NAME).then(function (cc) { return Promise.all([cc.delete(KEY), dropExtras(cc)]); }).catch(function () {}); } };
                    });
                });
            });
        }).catch(function () { return null; });
    }

    function sweep() {
        if (!window.caches) return;
        caches.open(CACHE_NAME).then(function (c) {
            return c.match(KEY).then(function (res) {
                // Без ключа хвостов не бывает: их пишет только putMany перед ключом, а
                // следующий put/putMany убирает недописанное — каждой странице сайта
                // незачем платить за пятнадцать удалений.
                if (!res) return;
                var ts = parseInt(res.headers.get(HDR_TS) || '0', 10);
                if (!ts || (Date.now() - ts) > TTL_MS) return Promise.all([c.delete(KEY), dropExtras(c)]);
            });
        }).catch(function () {});
    }

    /* Результат тула в двух формах:
         {blob, filename}                       — файл уже существует;
         {size, type, filename, make: fn}       — ЛЕНИВАЯ: файл будет собран
                                                  только при клике.
       Лениво нужно там, где результат живёт не файлом, а звуком в памяти:
       мастеринг держит AudioBuffer, и кодировать из него WAV на каждый
       refresh() значило бы платить ~50 МБ и заметную паузу за подсказку,
       которую пользователь, возможно, не нажмёт. Гейтам хватает размера,
       типа и имени — их и просим заранее; make() зовётся один раз, по клику.
       Нормализуем здесь, чтобы ни гейты, ни обработчик клика не знали про
       две формы. */
    function normalize(res) {
        if (!res) return null;
        if (res.blob) {
            if (!res.blob.size) return null;
            return { size: res.blob.size, type: res.blob.type || '',
                     filename: res.filename || 'file', hints: res.hints || null,
                     make: function () { return Promise.resolve(res.blob); } };
        }
        if (typeof res.make === 'function' && res.size > 0) {
            return { size: res.size, type: res.type || '',
                     filename: res.filename || 'file', hints: res.hints || null,
                     make: function () { return Promise.resolve().then(res.make); } };
        }
        return null;
    }

    /* ─── ГЕЙТЫ ─────────────────────────────────────────────────────────────
       Возвращает null, если переход в этот тул сработает, иначе — причину.
       Никаких собственных таблиц форматов и размеров: спрашиваем те же
       источники, которыми будет пользоваться сам целевой тул. */
    function refuseReason(chip, res, free) {
        if (!canTransport()) return 'no-transport';
        var size = res.size;
        if (free !== Infinity && free < size * 1.2) return 'quota';

        var accept = chip.getAttribute('data-accept') || '';
        // Аплоадер судит по имени и MIME, а не по байтам — поэтому лёгкая
        // «карточка» файла проверяется той же функцией, что и настоящий File.
        var probe = { name: res.filename, type: res.type };
        if (accept && window.ToolUploader && typeof window.ToolUploader._matchesAccept === 'function') {
            if (!window.ToolUploader._matchesAccept(probe, accept)) return 'format';
        } else if (accept) {
            // Аплоадер ещё не загрузился — сверяем хотя бы расширение, чтобы не
            // предложить .webm туда, где ждут только mp4.
            var ext = (res.filename.split('.').pop() || '').toLowerCase();
            var low = accept.toLowerCase();
            if (low.indexOf('/*') === -1 && low.indexOf('.' + ext) === -1) return 'format';
        }

        var kind = chip.getAttribute('data-kind') || 'video';
        var capMb = 0;
        if (typeof window.__effectiveFileLimit === 'function') {
            try { capMb = Math.round(window.__effectiveFileLimit(kind) / 1048576); } catch (_) {}
        }
        var hard = parseInt(chip.getAttribute('data-max-mb') || '0', 10);
        if (hard > 0) capMb = capMb > 0 ? Math.min(capMb, hard) : hard;
        var sizeMb = size / 1048576;
        if (capMb > 0 && sizeMb > capMb) return 'too-big';

        /* Слабое устройство: у автора жалобы был телефон с 2 ГБ. Кап выше уже
           учитывает память, но повторная ОБРАБОТКА тяжёлого файла на таком
           устройстве почти наверняка не доедет — не обещаем невозможного. */
        var dm = navigator.deviceMemory || 0;
        if (dm > 0 && dm <= 2 && sizeMb > 80) return 'weak-device';

        var slug = chip.getAttribute('data-slug') || '';
        if (slug && window.__toolLimit) {
            try {
                if (typeof window.__toolLimit.isBlocked === 'function' && window.__toolLimit.isBlocked(slug)) return 'blocked';
                if (typeof window.__toolLimit.remaining === 'function') {
                    var left = window.__toolLimit.remaining(slug);
                    if (left !== Infinity && left <= 0) return 'no-runs';
                }
            } catch (_) {}
        }
        return null;
    }

    /* ─── ПРОДЮСЕР ──────────────────────────────────────────────────────────
       mount(rail, getResult) — getResult() должен вернуть {blob, filename},
       ЛИБО ленивую карточку {size, type, filename, make}, либо null, если
       результата ещё нет. Тул зовёт refresh() после того, как результат готов
       (и после «Новой склейки», чтобы рейл спрятался). */
    /* API без возвращаемых объектов: тулы зовут mount()/refresh() ЧЕРЕЗ заглушку
       __sharedModule (инлайновый код тула исполняется раньше defer-скриптов, и
       вызовы копятся в очередь). Заглушка возвращает undefined, поэтому «ручку»
       возвращать нельзя — состояние держим здесь, адресуем по элементу рейла. */
    var _mounted = [];
    function _entry(rail) {
        for (var i = 0; i < _mounted.length; i++) if (_mounted[i].rail === rail) return _mounted[i];
        return null;
    }
    function refresh(rail) {
        var e = rail ? _entry(rail) : _mounted[0];
        if (e) e.refresh();
    }

    function mount(rail, getResult) {
        if (!rail || typeof getResult !== 'function') return;
        if (_entry(rail)) return;
        var chips = [].slice.call(rail.querySelectorAll('[data-slug]'));

        function refresh() {
            var res = null;
            try { res = normalize(getResult()); } catch (_) {}
            if (!res) { rail.hidden = true; return; }
            freeBytes().then(function (free) {
                var shown = 0, why = {};
                chips.forEach(function (chip) {
                    var reason = refuseReason(chip, res, free);
                    chip.hidden = !!reason;
                    if (reason) { why[reason] = (why[reason] || 0) + 1; } else { shown++; }
                });
                rail.hidden = shown === 0;
                ae('handoff_rail', {
                    shown: shown, total: chips.length, sizeMB: Math.round(res.size / 1048576),
                    ext: (res.filename.split('.').pop() || '').toLowerCase(),
                    hidden: Object.keys(why).sort().join(',') || 'none'
                });
            });
        }

        rail.addEventListener('click', function (e) {
            var chip = e.target.closest ? e.target.closest('[data-slug]') : null;
            if (!chip || chip.hidden) return;
            e.preventDefault();
            var res = null;
            try { res = normalize(getResult()); } catch (_) {}
            if (!res) return;
            var url = chip.getAttribute('data-url') || chip.getAttribute('href');
            if (!url) return;
            var slug = chip.getAttribute('data-slug') || '';
            chip.setAttribute('aria-busy', 'true');
            ae('handoff_click', { to: slug, sizeMB: Math.round(res.size / 1048576) });
            // Ленивая форма собирает файл ЗДЕСЬ — на клике, а не на каждом
            // refresh(); для уже готового блоба make() резолвится мгновенно.
            res.make()
                .then(function (blob) {
                    if (!blob || !blob.size) throw new Error('empty-result');
                    return put(blob, res.filename, (window.__TOOL_SLUG || (document.querySelector('meta[name="tool-slug"]') || {}).content || ''), res.hints);
                })
                .then(function () {
                    location.href = withParam(url);
                })
                .catch(function (err) {
                    chip.removeAttribute('aria-busy');
                    ae('handoff_fail', { to: slug, err: String((err && err.name) || err).slice(0, 40) });
                    // Честно: скачивание рядом по-прежнему работает, им и предлагаем воспользоваться.
                    if (window.__toast) window.__toast(t('failed'), 'error');
                });
        });

        _mounted.push({ rail: rail, refresh: refresh });
        refresh();
    }

    /* ─── ОДИНОЧНЫЙ ПЕРЕХОД ─────────────────────────────────────────────────
       carry(url, getResult) — для случая, когда переход уже описан в интерфейсе
       ОДНОЙ кнопкой-ссылкой, и рейл со списком чипов был бы дубликатом (так у
       анализатора сведения: «Применить это автоматически» ведёт в мастеринг).
       Ссылка остаётся настоящей ссылкой: перенос — БОНУС, а не условие.
       Не получилось положить файл — просто уходим по href, как и раньше, и
       пользователь загрузит файл руками. Поэтому здесь нет гейтов рейла: они
       нужны, чтобы не ОБЕЩАТЬ невозможного, а тут ничего не обещано. */
    function carry(link, getResult) {
        if (!link || typeof getResult !== 'function') return;
        link.addEventListener('click', function (e) {
            var res = null;
            try { res = normalize(getResult()); } catch (_) {}
            var url = link.getAttribute('data-url') || link.getAttribute('href');
            if (!res || !url || !canTransport()) return;      // обычный переход по ссылке
            e.preventDefault();
            link.setAttribute('aria-busy', 'true');
            var to = link.getAttribute('data-slug') || '';
            function go(ok) {
                ae('handoff_click', { to: to, sizeMB: Math.round(res.size / 1048576), carried: ok ? 1 : 0 });
                location.href = ok ? withParam(url) : url;
            }
            res.make()
                .then(function (blob) {
                    if (!blob || !blob.size) throw new Error('empty-result');
                    return put(blob, res.filename, (window.__TOOL_SLUG || (document.querySelector('meta[name="tool-slug"]') || {}).content || ''), res.hints);
                })
                .then(function () { go(true); })
                .catch(function (err) {
                    ae('handoff_fail', { to: to, err: String((err && err.name) || err).slice(0, 40) });
                    go(false);
                });
        });
    }

    /* ─── ПРИЁМНИК ──────────────────────────────────────────────────────────
       Ничего не требует от тула: находим аплоадер, который САМ принимает такой
       файл (у тулов бывает несколько зон — например видео + музыка), и отдаём
       файл штатным путём, вместе со всеми проверками аплоадера. */
    function pickZone(file) {
        var zones = [].slice.call(document.querySelectorAll('.tool-uploader'));
        if (!zones.length) return null;
        for (var i = 0; i < zones.length; i++) {
            var acc = zones[i].getAttribute('data-accept') || (zones[i].__uploaderInput && zones[i].__uploaderInput.getAttribute('accept')) || '';
            if (!acc) continue;
            if (window.ToolUploader && typeof window.ToolUploader._matchesAccept === 'function') {
                if (window.ToolUploader._matchesAccept(file, acc)) return zones[i];
            }
        }
        return zones[0];
    }

    function receive() {
        if (location.search.indexOf(PARAM + '=1') === -1) { sweep(); return; }
        // Параметр снимаем сразу: перезагрузка страницы не должна выглядеть как
        // «файл потерялся» (запись к тому времени уже удалена).
        try { history.replaceState({}, '', location.pathname + location.search.replace(new RegExp('[?&]' + PARAM + '=1'), '').replace(/^&/, '?') + location.hash); } catch (_) {}
        take().then(function (got) {
            if (!got) { ae('handoff_received', { from: '', ok: 0, err: 'empty-or-stale' }); return; }

            /* Зоны аплоадера провязываются на DOMContentLoaded (tool-uploader.js:1449),
               а сам аплоадер может грузиться дольше нас (ISP/AV режут крупные скрипты,
               __jsFallback перезагружает файл). Раньше приёмник в этом случае сдавался
               СРАЗУ — и файл был уже удалён из кэша. Ждём готовности до 15 с, проверяя
               10 раз в секунду; payload при этом цел, так что даже полный провал
               оставляет пользователю возможность прийти по ссылке ещё раз. */
            var waited = 0, STEP = 100, LIMIT = 15000;
            (function attempt() {
                var zone = pickZone(got.file);
                var ready = zone && typeof zone.__uploaderInjectFile === 'function';
                if (!ready && zone && !zone.__toolUploaderWired && window.ToolUploader
                    && !window.ToolUploader.__isStub && typeof window.ToolUploader.wire === 'function') {
                    try { window.ToolUploader.wire(zone); } catch (_) {}
                    ready = typeof zone.__uploaderInjectFile === 'function';
                }
                if (ready) {
                    // the hints first: a tool that meets the file with a look (a template, a title)
                    // must know it before the file's own handlers run
                    var files = got.files && got.files.length ? got.files : [got.file];
                    var arrival = { from: got.from, hints: got.hints || null, file: got.file, files: files };
                    window.__toolHandoffArrival = arrival;
                    try { document.dispatchEvent(new CustomEvent('tool-handoff:arrived', { detail: arrival })); } catch (_) {}
                    // Пачка — одним выбором, как если бы человек выбрал все файлы
                    // разом: по одному зона одиночного выбора оставила бы последний.
                    if (files.length > 1 && typeof zone.__uploaderInjectFiles === 'function') zone.__uploaderInjectFiles(files, 'inter_tool_route');
                    else zone.__uploaderInjectFile(got.file, 'inter_tool_route');
                    // Удаляем ТОЛЬКО после фактической доставки.
                    got.drop();
                    ae('handoff_received', { from: got.from, ok: 1, sizeMB: Math.round(got.size / 1048576), waitedMs: waited, hints: got.hints ? 1 : 0, n: files.length });
                    if (window.__toast) window.__toast(t('arrived'), 'success');
                    if (window.__announce) window.__announce(t('arrived'));
                    return;
                }
                waited += STEP;
                if (waited < LIMIT) { setTimeout(attempt, STEP); return; }
                // Не дождались: файл НЕ удаляем — пусть переход можно повторить.
                ae('handoff_received', { from: got.from, ok: 0, err: zone ? 'no-inject' : 'no-uploader', waitedMs: waited });
                if (window.__toast) window.__toast(t('failed'), 'error');
            })();
        });
    }

    function t(key) {
        var L = ((window.__LOCALE || 'en') + '').slice(0, 2);
        var M = {
            arrived: {
                ru: 'Файл перенесён — можно продолжать',
                en: 'File carried over — you can continue',
                de: 'Datei übernommen — Sie können fortfahren',
                es: 'Archivo trasladado: puedes continuar',
                fr: 'Fichier transféré — vous pouvez continuer', uk: 'Файл перенесено — можна продовжувати',
                pt: 'Arquivo transferido — pode continuar',
                id: 'Berkas dipindahkan — Anda bisa lanjut',
                ko: '파일을 가져왔습니다 — 계속하세요',
                ar: 'تم نقل الملف — يمكنك المتابعة',
                tr: 'Dosya taşındı — devam edebilirsiniz'
            },
            failed: {
                ru: 'Не удалось перенести файл. Скачайте его и загрузите в нужный инструмент.',
                en: 'Could not carry the file over. Download it and upload it to the other tool.',
                de: 'Datei konnte nicht übernommen werden. Laden Sie sie herunter und im anderen Tool hoch.',
                es: 'No se pudo trasladar el archivo. Descárgalo y súbelo a la otra herramienta.',
                fr: 'Impossible de transférer le fichier. Téléchargez-le et importez-le dans l’autre outil.', uk: 'Не вдалося перенести файл. Скачайте його та завантажте в інший інструмент.',
                pt: 'Não foi possível transferir o arquivo. Baixe-o e envie-o na outra ferramenta.',
                id: 'Gagal memindahkan berkas. Unduh lalu unggah di alat lain.',
                ko: '파일을 옮기지 못했습니다. 내려받아 다른 도구에 올려 주세요.',
                ar: 'تعذّر نقل الملف. نزّله وحمّله في الأداة الأخرى.',
                tr: 'Dosya taşınamadı. Dosyayı indirip diğer araca yükleyin.'
            }
        };
        return (M[key] && (M[key][L] || M[key].en)) || '';
    }

    /* Пришёл ли ЭТОТ файл из соседнего тула — от него ('enhance-video'…) или ''. Зона может
       отдать тулу копию (FileBytes), поэтому сверка ещё и по имени с размером. Зачем приёмнику:
       файл из нашего тула уже наш выход, и его качество по умолчанию — «Высокое» (28.10.2026,
       docs/why/handoff-keeps-quality.md). */
    function cameFrom(file) {
        var a = window.__toolHandoffArrival;
        if (!a || !a.file || !file) return '';
        return (a.file === file || (a.file.name === file.name && a.file.size === file.size)) ? String(a.from || 'tool') : '';
    }

    window.__toolHandoff = { mount: mount, refresh: refresh, carry: carry, available: canTransport, cameFrom: cameFrom, _put: put, _putMany: putMany, _take: take, _normalize: normalize, _withParam: withParam };

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', receive);
    else receive();

    if (typeof window.__drainSharedModule === 'function') window.__drainSharedModule('__toolHandoff');
})();
